<button mat-fab color="primary" class="scroll-to-top-btn" [class.visible]="isVisible" (click)="scrollToTop()"
    aria-label="Scroll to top">
    <mat-icon>keyboard_arrow_up</mat-icon>
</button>